import axios from '@/axios'
import { notifyServerError } from '@/layouts/notifies'

export default {
  uploadFile(context, event) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i]
        formData.append(`files[${i}]`, file)
      }
      axios
        .post('uploads', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          resolve(response) // response.data[0] is file
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchFile(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`uploads/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  downloadFile({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      const file = getters.fileUrl(id)
      if (file) {
        resolve(file)
      }
      axios
        .get(`download/${id}`, {
          responseType: 'blob'
        })
        .then(response => {
          const url = URL.createObjectURL(response.data)
          commit('ADD_FILE', { id, url })
          resolve(url)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeFile(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`uploads/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
